<template>
	<apexchart :width="width" :height="height" type="pie" :options="chartOptions" :series="series" />
</template>

<script>
	export default {
		name: 'AppPieChart',
		props: {
			name: {
				type: String,
			},
			labels: {
				required: true,
				type: [Array],
			},
			series: {
				required: true,
				type: [Array],
			},
			width: {
				default: '100%',
			},
			height: {
				default: '100%',
			},
		},
		computed: {
			chartOptions() {
				return {
					chart: {
						toolbar: {
							show: true,
							export: {
								csv: {
									filename: undefined,
									columnDelimiter: ',',
									headerCategory: 'Labels',
									headerValue: 'Values',
								},
								svg: {
									filename: undefined,
								},
								png: {
									filename: undefined,
								},
							},
						},
					},
					dataLabels: {
						enabled: true,
						formatter: (val, opts) => {
							return `${opts.w.globals.series[opts.seriesIndex].toLocaleString()} (${val.toFixed(2)}%)`;
						},
						offsetX: 0,
						offsetY: 0,
						style: {
							fontSize: '15px',
							fontFamily: 'Arial, sans-serif',
							fontWeight: 'bold',
							colors: ['#252525'],
						},
						dropShadow: {
							enabled: false,
						},
					},
					tooltip: {
						enabled: true,
						y: {
							formatter: (val, opts) => {
								return `${val.toLocaleString()} (${(
									(opts.globals.series[opts.seriesIndex] /
										opts.globals.series.reduce((a, b) => a + b, 0)) *
									100
								).toFixed(2)}%)`;
							},
						},
					},
					labels: this.labels,
					legend: {
						position: 'left',
						labels: {
							useSeriesColors: true,
						},
						formatter: function(val, opts) {
							return (
								val +
								' - ' +
								opts.w.globals.series[opts.seriesIndex].toLocaleString() +
								` (${(
									(opts.w.globals.series[opts.seriesIndex] /
										opts.w.globals.series.reduce((a, b) => a + b, 0)) *
									100
								).toFixed(2)}%)`
							);
						},
					},
				};
			},
		},
	};
</script>
